<template>
  <div class="title-text">
    <div class="d-flex">
      <v-icon @click="toggleFolder">
        {{ isOpen ? 'mdi-folder-open-outline' : 'mdi-folder-outline' }}
      </v-icon>
      <div @click="toggleFolder" class="mt-1 ml-2">{{ folder.title }}</div>
    </div>
    <div v-if="isOpen" class="ml-4 mt-1">
      <div v-for="(item, index) in folder.docCategories" :key="index">
        <div class="ml-4 mt-2">
          <a v-if="item.index === 1" @click="openDialog(item)">Tài liệu chung</a>
          <div v-else-if="item.index === 2">
            <div class="mt-2">
              <a @click="openDialog(item)">{{ `Lớp ${get(item, 'title', '')}` }}</a>
            </div>
          </div>
        </div>
      </div>
      <TreeFolder
        v-for="subFolder in folder.grades"
        :key="subFolder.id"
        :folder="subFolder"
        @setItem="$emit('setItem', $event)"
      />
    </div>
  </div>
</template>

<script>
import get from 'lodash-es/get'
import { mapActions } from 'vuex'
export default {
  name: 'TreeFolder',
  components: {},
  props: {
    folder: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.selectedItem = {}
  },
  data() {
    return {
      isOpen: false,
      showDialog: false,
      openSubFolders: {},
      selectedItem: {},
      get,
    }
  },
  methods: {
    ...mapActions({
      fetchDocument: 'gradeDocument/fetchDocument',
    }),
    toggleFolder() {
      this.isOpen = !this.isOpen
    },
    toggleSubFolder(id) {
      this.$set(this.openSubFolders, id, !this.openSubFolders[id])
    },
    isSubFolderOpen(id) {
      return !!this.openSubFolders[id]
    },
    async refreshDocumentTable(item) {
      this.$loading.active = true
      try {
        await this.fetchDocument({ docCategory: item._id })
      } catch (error) {
        this.$alert.error('Không tải được tài liệu')
      } finally {
        this.$loading.active = false
      }
    },
    async openDialog(item) {
      await this.refreshDocumentTable(item)
      this.$emit('setItem', item)
    },
  },
}
</script>

<style scoped>
.ml-4 {
  margin-left: 1rem;
}
.title-text {
  font-size: 16px;
}
</style>
